import React, { useState } from "react";
import {
  DocumentArrowDownIcon,
  PrinterIcon,
  PlusIcon,
  MapPinIcon,
  UsersIcon,
  ChevronUpIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/solid";
import toast from "react-hot-toast";

export default function HeaderDataCleaning({
  tabs,
  filter,
  setFilter,
  locationOptions,
  selectedLocation,
  setSelectedLocation,
  selectedGender,
  setSelectedGender,
  filteredDataForUI,
  dataForReport,
  searchTerm,
  setSearchTerm,
  handleExportExcel,
  printDataCleaningList,
  handleAdd,
}) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const genderOptions = ["semua", "laki-laki", "perempuan"];
  const totalPetugas = filteredDataForUI?.length || 0;

  return (
    <header
      className={`sticky top-0 z-10 bg-white/80 backdrop-blur-2xl rounded-2xl shadow-md border border-white/50 mb-6 transition-all duration-500 overflow-hidden ${
        isCollapsed ? "max-h-20" : "max-h-[800px]"
      }`}
    >
      {/* Judul dan Toggle */}
      <div className="flex justify-between items-center p-4">
        <h2 className="text-2xl font-bold text-gray-800">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-teal-500">
            Data
          </span>{" "}
          Cleaning Service
        </h2>

        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-2 rounded-full hover:bg-gray-200 transition"
          title={isCollapsed ? "Tampilkan Filter" : "Sembunyikan Filter"}
        >
          {isCollapsed ? (
            <ChevronDownIcon className="w-6 h-6 text-gray-600" />
          ) : (
            <ChevronUpIcon className="w-6 h-6 text-gray-600" />
          )}
        </button>
      </div>

      {/* Konten Header */}
      {!isCollapsed && (
        <div className="p-6 space-y-6 border-t border-gray-100">
          {/* Tab status */}
          <div className="flex flex-wrap justify-center md:justify-start gap-2 bg-white/50 border p-1 rounded-xl">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setFilter(tab.id)}
                className={`flex items-center gap-2 px-3 py-1.5 text-sm font-semibold rounded-lg transition-all ${
                  filter === tab.id
                    ? "bg-green-100 text-green-800 shadow-sm"
                    : "text-gray-700 hover:text-green-700"
                }`}
              >
                <span>{tab.label}</span>
                <span
                  className={`text-xs font-bold text-white px-2 py-0.5 rounded-full ${tab.color}`}
                >
                  {tab.count}
                </span>
              </button>
            ))}
          </div>

          {/* Filter */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
            {/* Lokasi */}
            <div>
              <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <MapPinIcon className="w-5 h-5 text-gray-500" />
                Lokasi Kerja
              </label>
              <select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                className="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-lg bg-white/50 focus:ring-2 focus:ring-teal-500"
              >
                {locationOptions.map((location) => (
                  <option key={location} value={location}>
                    {location === "semua" ? "Semua Lokasi" : location}
                  </option>
                ))}
              </select>
            </div>

            {/* Jenis Kelamin */}
            <div>
              <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <UsersIcon className="w-5 h-5 text-gray-500" />
                Jenis Kelamin
              </label>
              <div className="flex justify-between bg-white/50 border border-gray-300 rounded-xl p-1 shadow-sm">
                {genderOptions.map((g) => (
                  <button
                    key={g}
                    onClick={() => setSelectedGender(g)}
                    className={`flex-1 px-3 py-1.5 text-sm font-semibold rounded-lg transition-all ${
                      selectedGender === g
                        ? "bg-gradient-to-r from-green-500 to-teal-500 text-white shadow"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    {g === "semua"
                      ? "👥 Semua"
                      : g === "laki-laki"
                      ? "👨 Laki-laki"
                      : "👩 Perempuan"}
                  </button>
                ))}
              </div>
            </div>

            {/* Pencarian */}
            <div>
              <label className="text-sm font-semibold text-gray-700 mb-2 block">
                Cari Data
              </label>
              <input
                type="text"
                placeholder="Cari nama atau NIK..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-4 pr-3 py-2 border border-gray-300 rounded-lg bg-white/50 focus:ring-2 focus:ring-green-500"
              />
            </div>
          </div>

          {/* Info & Tombol */}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
            <p className="text-sm text-gray-600">
              Menampilkan{" "}
              <span className="font-bold text-gray-800">{totalPetugas}</span> data
            </p>
            <div className="flex items-center gap-2">
              <button
                onClick={handleExportExcel}
                disabled={dataForReport.length === 0}
                className={`inline-flex items-center gap-2 px-3 py-2 font-semibold rounded-lg shadow-md transition-all ${
                  dataForReport.length === 0
                    ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                    : "bg-gradient-to-r from-green-500 to-teal-600 text-white hover:scale-105"
                }`}
              >
                <DocumentArrowDownIcon className="w-5 h-5" />
                Excel
              </button>
              <button
                onClick={() => {
                  if (filteredDataForUI.length === 0)
                    return toast.error("Tidak ada data untuk dicetak!");
                  printDataCleaningList(filteredDataForUI, searchTerm);
                  toast.success("Data siap dicetak!");
                }}
                disabled={filteredDataForUI.length === 0}
                className={`inline-flex items-center gap-2 px-3 py-2 font-semibold rounded-lg shadow-md transition-all ${
                  filteredDataForUI.length === 0
                    ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                    : "bg-gradient-to-r from-green-500 to-teal-600 text-white hover:scale-105"
                }`}
              >
                <PrinterIcon className="w-5 h-5" />
                Cetak
              </button>
              <button
                onClick={handleAdd}
                className="inline-flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-green-500 to-teal-600 text-white font-semibold rounded-lg shadow-md hover:scale-105 transition-all"
              >
                <PlusIcon className="w-5 h-5" />
                Tambah
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
